export default __webpack_public_path__ + "static/media/P10008.def240ec.png";